<template>

    <modal-container>

        <div>

            <!-- Top navbar -->
            <modal-header
                :title="'Search & Browse'"
                :right="'close'"
                :noIcon="true">
            </modal-header>

            <template>

                <!-- Loading animation -->
                <lottie class="loading-animation" :options="{animationData: $root.loadAnimation}" v-if="initLoad"/>

                <!-- Page overlay -->
                <div class="position-absolute" :class="{ overlay: $root.isOverlayed }"></div>

                <!-- Main content -->
                <div class="container" v-if="!initLoad">

                    <!-- Control Panel -->
                    <controls-div>

                        <!-- Search field -->
                        <search-bar class="mb-2" :onfocus="onfocus"></search-bar>

                    </controls-div>

                    <div class="position-relative">

                        <!-- Search suggestions dropdown -->
                        <search-suggestions :shown="$root.isOverlayed"></search-suggestions>

                        <!-- Categories list -->
                        <div class="font-xs font-weight-bolder mb-3 mt-6">BROWSE BY CATEGORY</div>
                        <ul>
                            <li class="d-flex align-items-center py-1"
                                v-for="(cat, key) in categories"
                                :key="key"
                                @click="$router.push({
                                    name: 'listing',
                                    query: {
                                        type:'category',
                                        selected: cat.id,
                                        name: cat.name
                                    }
                                })">
                                <div class="category-icon d-flex align-items-center justify-content-center mr-4">
                                    <img v-if="cat.iconType == 'SVG'" :src="'data:image/svg+xml;base64,' + cat.icon">
                                    <img v-else-if="cat.iconType == 'JPG'" class="h-50" :src="'data:image/png;base64,' + cat.icon">
                                    <img v-else class="h-35" :src="'images/icon-cat-more.svg'">
                                </div>
                                <div class="font-md" v-html="cat.name"></div>
                                <info-tag class="ml-auto"><span v-html="cat.numberOfProduct + ' deals'"></span></info-tag>
                            </li>
                        </ul>
                        <hr class="my-7">

                        <!-- Brands list -->
                        <div class="font-xs font-weight-bolder mb-3">BROWSE BY BRANDS</div>
                        <ul>
                            <li class="d-flex align-items-center py-2"
                                v-for="(brand, key) in brands"
                                v-if="key < 15"
                                :key="key"
                                @click="$router.push({
                                    name: 'listing',
                                    query: {
                                        type: 'brand',
                                        selected: brand.id,
                                        name: brand.name
                                    }
                                })">
                                <div class="font-md" v-html="brand.name"></div>
                                <info-tag class="ml-auto"><span v-html="brand.numberOfProduct + ' deals'"></span></info-tag>
                            </li>
                        </ul>
                    </div>
                </div>

            </template>

        </div>

    </modal-container>

</template>

<script>
    const SearchBar = Vue.component('search-bar', require('../components/search/SearchBar.vue').default);
    const SearchSuggestions = Vue.component('search-suggestions', require('../components/search/SearchSuggestions.vue').default);

    export default {

        props: {
            params: {
                default: null,
            },
        },

        components: { SearchBar, SearchSuggestions },

        data: function () {
            return {
                initLoad: true,
                categories: [],
                brands: [],
                onfocus: false,
            }
        },

        created: function() {
            this.onfocus = this.$root.isOverlayed || (this.params != null && this.params.onfocus)

            axios
                .get("get_lists")
                .then(response => {
                    this.initLoad = false
                    this.categories = response.data['categories']
                    this.brands = response.data['brands']
                })
        },
    }
</script>

<style scoped>
.nav-tabs {
    margin-top: 0.625rem;
}
.listing-container {
    margin-bottom: 2.1875rem;
}
.cat-icon {
    width: 50px;
    height: 50px;
}
.cat-icon img {
    max-width: 80%;
    max-height: 80%;
}
</style>
